import api from '../../service/modules/index'
import Api from '../../service/modules/complaintApis'
export default {
    namespaced: true,
    state: {
      noticeNumTravel: 0,
      noticeNumComplain: 0,
      noticeNumIntegrity: 0,
      noticeNumRefund: 0,
      noticeNumGuide: 0,
      noticeNumAttract: 0,
      userAreaCode: 0,
      noticeNumTouristPrivacy: 0,
    },
    mutations: {
        // 旅行社
        setTravelNum: (state, data) => {
          state.noticeNumTravel = data;
        },
        // 投诉
        setComplainNum: (state, data) => {
          state.noticeNumComplain = data;
        },
        // 诚信
        setIntegrityNum: (state, data) => {
          state.noticeNumIntegrity = data;
        },
        // 退货
        setRefundNum: (state, data) => {
          state.noticeNumRefund = data;
        },
        setGuideNum: (state, data) => {
          state.noticeNumGuide = data;
        },
        //招商引资
        setNoticeNumAttract: (state, data) => {
          state.noticeNumAttract = data;
        },
        // 用户的CODE
        setUserAreaCodeNum: (state, data) => {
          state.userAreaCode = data;
        },
        // 团队监管
        setTouristPrivacyNum: (state, data) => {
          state.noticeNumTouristPrivacy = data;
        },
    },
    actions: {
        getTravelNum: (context) => {
          api.noticeNumTravel({ p: 1, pageSize: 80, status: 0, type: 1 }).then(res => {
            console.log('res:', res)
            context.commit('setTravelNum', res.data.pagination.total)
            console.log('拉取旅行社notice:', res.data)
          })
        },
        getComplainNum: (context) => {
          Api.common.getNewhandleMessageCount({}).then(res => {
              context.commit('setComplainNum', (res.data || {}).num)
              console.log('拉取投诉notice:', res.data)
          })
        },
        getIntegrityNum: (context) => {
          api.noticeNumIntegrity({}).then(res => {
              context.commit('setIntegrityNum', res.data)
              console.log('拉取诚信notice:', res.data)
          })
        },
        getRefundNum: (context) => {
          api.noticeNumRefund({}).then(res => {
              context.commit('setRefundNum', res.data)
              console.log('拉取退货notice:', res.data)
          })
        },
        getGuideNum: (context) => {
          api.noticeNumGuide({ p: 1, pageSize: 80, status: 0 }).then(res => {
              context.commit('setGuideNum', res.data.pagination.total)
              console.log('拉取导游notice:', res.data)
          })
        },
        getAttractNum: (context, data) => {
          if (data) {
            context.commit('setAttractNum', data)
          }
        },
        getUserAreaCodeNum: (context, data) => {
          console.log('data', data)
          context.commit('setUserAreaCodeNum', data)
        }
    }
  }
